"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ActionTypes = require("../actions/ActionTypes");

var initialState = {
  gates: [],
  portal: {},
  user: {
    scopes: []
  }
};

var auth = function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.INITIALIZE_AUTH:
      return {
        user: action.user,
        gates: action.gates,
        portal: action.portal
      };

    case _ActionTypes.INITIALIZE_ADMIN_AUTH:
      return (0, _extends2.default)({}, state, {
        user: action.user
      });

    case _ActionTypes.HUB_FETCH_RECEIVED:
      {
        var portal = (0, _extends2.default)({}, state.portal, {
          scopes: action.payload
        });
        return (0, _extends2.default)({}, state, {
          portal: portal
        });
      }

    default:
      return state;
  }
};

var _default = auth;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/auth.js
// module id = 636
// module chunks = 209 210 211 212